<template>
    <div v-if="settings['onfire_count'] <= user.streak" class="trophy-on-fire card card-shadow flex flex-align-end">
        <div class="on-fire-top card-inner align-center">
            <i class="fa fa-fire"></i>
            <p class="bold-text">{{ translations['streak.onfire'] }}.</p>
            <span class="extra-light-text small-text">{{ translations['streak.for'] }} {{user.streak}} {{ translations['streak.fire_days'] }}!</span>
        </div>
        <div class="on-fire-bottom card-inner background-lightblue on-fire">
            <p class="light-text small-text">{{ translations['streak.within'] }} <strong class="secondary-c">{{user.streakCountDown}}</strong> {{ translations['streak.timer_done'] }}?</p>
            <div class="burn-bar-wrapper flex relative" style="flex-basis: 100%; background-color:#efefef">
                <div class="on-fire-item burn-bar" :style="{ 'flex-basis': 100/24 * user.streakCountDown + '%'}" >
                    <i class="fa fa-fire fire-timer" :style="{ 'left': 100/24 * user.streakCountDown - 3 + '%'}"></i>
                    <div class="animated-bar-wrapper relative" :style="{ 'flex-basis': 100/24 * user.streakCountDown + '%'}">
                        <div class="animated-bar"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else class="trophy-on-fire card card-shadow flex flex-align-end">
        <div class="on-fire-top card-inner align-center">
            <i class="far fa-fire"></i>
            <p class="bold-text">{{ translations['streak.fire_almost'] }}.</p>
        </div>
        <div class="on-fire-bottom card-inner background-lightblue">
            <p v-if="(settings['onfire_count'] - user.streak) != 1" class="light-text small-text">{{ translations['streak.streak_post'] }} {{ settings['onfire_count'] - user.streak }} {{ translations['streak.day_plural'] }}, {{ translations['streak.fire_tobe'] }}!</p>
            <p v-else class="light-text small-text">{{ translations['streak.streak_post'] }} {{ translations['streak.day_single'] }}, {{ translations['streak.fire_tobe'] }}!</p>
            <div class="flex">
                <div class="on-fire-item" :class="{'active': index <= user.streak}" v-for="index in fireCount" :key="index"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'
    import {mapState} from 'vuex';

    export default {
        name: 'TrophyFire',
        mixins: [Global],

        created() {
            let self = this;
        },

        computed: {
            ...mapState([
                'settings',
            ]),

            fireCount() {
                if(this.settings.onfire_count) {
                    return parseInt(this.settings.onfire_count);
                } else {
                    return 0;
                }
            }
        }
    }

</script>

<style lang="scss">
    .trophy-on-fire {
        height: calc(100% - 20px);

        .on-fire-top {
            width: 100%;

            i {
                color: darkred;
                font-size: 35px;

                &.fa {
                    animation: grow 2s infinite linear;
                    animation-delay: 0.5s;
                }
            }

            p {
                color: darkred;
                margin-top: 10px;
                margin-bottom: 3px;
            }
        }

        .on-fire-bottom {
            width: 100%;
            border-radius: 0 0 5px 5px;

            p {
                margin-bottom: 15px;
            }

            .flex {
                justify-content: space-between;

                .on-fire-item {
                    border-radius: 10px;
                    height: 5px;
                    background: #c7c7c7;
                    flex: 1;
                    margin-left: 3px;
                    margin-right: 3px;

                    .animated-bar-wrapper {
                        overflow: hidden;
                        height: 5px;

                        .animated-bar {
                            position: absolute;
                            width: 200%;
                            left: 0;
                            top: 0;
                            background-image: linear-gradient(142deg, #f5d595 25%, #fff 25%, #fff 50%, #f5d595 50%, #f5d595 75%, #fff 75%, #fff 100%);
                            background-size: 16.24px 12.74px;
                            height: 100%;
                            animation: moveleft 12s infinite linear;
                        }
                    }

                    &.active {
                        background: #8b0000;
                    }

                    &.burn-bar {
                        /*position: relative;*/
                        flex: none;
                        //background-image: linear-gradient(142deg, #f5d595 25%, #fff 25%, #fff 50%, #f5d595 50%, #f5d595 75%, #fff 75%, #fff 100%);
                        margin-left: 0;
                        margin-right: 0;
                        //background-size: 16.24px 12.74px;
                        background: none;
                        max-width: 100%;
                    }
                }
            }

            .fire-timer{
                position: absolute;
                width: 1px;
                color: #8b0000;
                font-size: 20px;
                bottom: -6px;
                left: calc(87.5% - 10px);
                animation: grow 2s infinite linear;
                z-index: 1;
            }

            @keyframes grow {
                0% {
                    transform: scale(1);
                    color: #8b0000;
                }
                50% {
                    transform: scale(1.1);
                    color: #f58536;
                }
                100% {
                    transform: scale(1);
                    color: #8b0000;
                }
            }

            @keyframes moveleft {
                0% {
                    left: 0;
                }
                100% {
                    left: -99%;
                }
            }

            &.on-fire {
                .burn-bar-wrapper {
                    border-radius: 10px;
                }
            }
        }

        @media(max-width: 1100px) {
            height: auto;
        }
    }
</style>